import React from 'react';
import checkCircle from "../../images/check-circle.svg";
import errorImg from "../../pages/ResponsePages/imgs/error.png";

const ResultStep = ({ subscricaoFeita, erroSubscricao, mensagemErro, onClose }) => {
    if (subscricaoFeita) {
        return (
            <div className="sucesso-finalizado">
                <img src={checkCircle} alt="Sucesso" width="64" />
                <h2 style={{ color: "#f60" }}>Subscrição efetuada com sucesso!</h2>
            </div>
        );
    }

    if (erroSubscricao) {
        return (
            <div className="erro-finalizado">
                <div className="icone-check">
                    <img src={errorImg} alt="Erro" width="64" height="64" />
                </div>
                <h2 >Erro ao processar a subscrição</h2>
            </div>
        );
    }

    return null;
};

export default ResultStep;
